import {USER_LOGIN_REQUEST,USER_LOGIN_SUCCESS,USER_LOGIN_FAIL } from "../constants/userConstants"
import axios from 'axios'
import { USER_LOGOUT } from "../constants/userConstants"
import {USER_REGISTER_REQUEST,USER_REGISTER_SUCCESS,USER_REGISTER_FAIL, } from "../constants/userConstants"

// const GBG_URL=import.meta.env.GBG_BASE_URL

export const loginAction=(userCredentials)=>async(dispatch)=>{
    try{
        dispatch({ type:USER_LOGIN_REQUEST})
        const config={headers:{'Content-type':'application/json'}}
        const {data}=await axios.post("https://gbg-cs1u.onrender.com/login",userCredentials,config)
        dispatch({ type:USER_LOGIN_SUCCESS, payload:data})
        localStorage.setItem('userInfo',JSON.stringify(data))
    }
    catch(error) {  
        console.log("error",error)
        dispatch({type: USER_LOGIN_FAIL, payload:error?.response?.data ? error.response.data.message: error.message});
    }
}

// export const logout=()=>(dispatch)=>{ localStorage.removeItem('userInfo') ,dispatch({type:USER_LOGOUT})}

export const signUpAction=(userSignUpCredentials)=>async(dispatch)=>{
    try{
        dispatch({ type:USER_REGISTER_REQUEST})
        const config={headers:{'Content-type':'application/json'}}
        const {data}=await axios.post("https://gbg-cs1u.onrender.com/signUp",userSignUpCredentials,config)
        dispatch({type:USER_REGISTER_SUCCESS,payload:data})
    }
    catch(error) {
        console.log("error",error)
        dispatch({ type: USER_REGISTER_FAIL, payload:error?.response?.data ? error.response.data.message: error.message});
}
}